app.factory('stripe', ['$http','Config','CacheFactory','$rootScope','helper', function($http,Config,CacheFactory,$rootScope,helper) {

	var factoryFns =  {
		
	  	createToken: function(data,cardNumber,stripe, type){
			factoryFns.clearError();
	  		helper.showLoader();
		  	//then send payment request
        	stripe.createToken(
				  cardNumber
			).then(function(result) {
			  if (result.error) {
			  	helper.hideLoader();
                factoryFns.showError(result.error.message);
			  } else {
			  	const customerTokenData = Object.assign({}, data, {token_id:result.token.id});
			    //send request to create a customer
			    fetch('/checkout/create-customer', {
			      method: 'POST',
			      headers: {
			        'Content-Type': 'application/json',
			        'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
			      },
			      body: JSON.stringify(customerTokenData)
			    }).then(function(result) {
			    	result.json().then(function(json) {
			    		if (json.error) {
		    				// Show error from server on payment form
							helper.hideLoader();
							factoryFns.showError(json.error);
			    		}else{
			    			var customer_id = json.customer_id;
					        factoryFns.createPaymentMethod(customer_id,cardNumber,data,stripe, type);
			    		}
			    	});
			    });
			  }
			});
	  	},
		  createPaymentMethod: function(customer_id,cardNumber,data,stripe){

			stripe.createPaymentMethod(
				'card',
				cardNumber
		  ).then(function(result) {
			if (result.error) {
					helper.hideLoader();
					factoryFns.showError(result.error.message);
			} else {
				const paymentIntentTokenData = Object.assign({}, data, {payment_method_id:result.paymentMethod.id,customer_id:customer_id});

			  // Send paymentMethod.id to server
			  fetch('/checkout/complete-payment', {
				method: 'POST',
				headers: {
				  'Content-Type': 'application/json',
				  'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
				},
				body: JSON.stringify(paymentIntentTokenData)
			  }).then(function(result) {
				// Handle server response (see Step 3)
				result.json().then(function(json) {

					if (json.error) {
					  // Show error from server on payment form
					  helper.hideLoader();
					  factoryFns.showError(json.error);
				  }else{
					  factoryFns.handleServerResponse(json,data,stripe,customer_id);
				  }

				})
			  });
			}
		  });
		},
	  	handleAction: function(response,data,stripe,customer_id) {
			stripe.handleCardAction(
				response.payment_intent_client_secret
			).then(function(result) {
				if (result.error) {
					// Show error in payment form
					helper.hideLoader();
					factoryFns.showError(result.error.message);

				} else {
					const handleActionData = Object.assign({}, data, {payment_intent_id:result.paymentIntent.id,customer_id:customer_id});
					// The card action has been handled
					// The PaymentIntent can be confirmed again on the server
					fetch('/checkout/complete-payment', {
						method: 'POST',
						headers: {
							'Content-Type': 'application/json',
							'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
						},
						body: JSON.stringify(handleActionData)
					}).then(function(confirmResult) {
						return confirmResult.json();
					}).then(function(result) {
						if (result.error) {
							// Show error in payment form
							helper.hideLoader();
							factoryFns.showError(result.error);
						}else{
							factoryFns.handleServerResponse(result,data,stripe);
						}
				    });
				}
			});
		},
	  	handleServerResponse: function(response,data,stripe,customer_id){
			if (response.error) {
				// Show error from server on payment form
				helper.hideLoader();
				factoryFns.showError(response.error.message);
			} else if (response.requires_action) {
				// Use Stripe.js to handle required card action
				factoryFns.handleAction(response,data,stripe,customer_id);
			} else {
				const paymentSuccessData = Object.assign({}, data, {payment_id:response.payment_id});

				// Show success message
				fetch('/checkout/payment-success', {
					method: 'POST',
					headers: {
						'Content-Type': 'application/json',
						'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
					},
					body: JSON.stringify(paymentSuccessData)
				}).then(function(result) {
					result.json().then(function(json) {
						$rootScope.$broadcast('saveOrderEvent', {
			                orderID: json.orderID,
			                transID: json.transID
			            });
					});
				});
			}
	  	},
		paymentIntent: function(data,stripe, type){ //initial klarna payment intent
			const customerTokenData = Object.assign({}, data);
			//send request to create a customer
			fetch('/checkout/create-customer', { //create new customer key
			  method: 'POST',
			  headers: {
				'Content-Type': 'application/json',
				'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
			  },
			  body: JSON.stringify(customerTokenData)
			}).then(function(result) {
				result.json().then(function(json) {
					if (json.error) {
						// Show error from server on payment form
						helper.hideLoader();
						factoryFns.showError(json.error, type);
					}else{
						var customer_id = json.customer_id;
						const paymentIntentTokenData = Object.assign({}, data, {paymentMethodType: 'klarna',data: data, type: type, customer_id: customer_id});
						fetch('/checkout/create-payment-intent', { //create payment intent related the customer id and assign the type to klarna
							method: 'POST',
							headers: {
								'Content-Type': 'application/json',
								'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
							},
							body: JSON.stringify(paymentIntentTokenData)
							}).then(function(result) {
								result.json().then(function(json) {
									stripe.confirmKlarnaPayment( //use stripe method to confirm the klarna payment
										json.payment_intent_client_secret,
										{
										payment_method: {
											billing_details: {
												email: data.quote.email,
												name: data.quote.name,
												phone: data.quote.telephone,
												address: {
													line1: data.address.billing.address1,
													line2: data.address.billing.address2,
													city: data.address.billing.town,
													county: data.address.billing.County,
													postal_code: data.address.billing.postCode,
													country: data.address.billing.country,
												},
											},
										},
										return_url:  Config.base_url + 'checkout/payment', //redirects us back to the page we left where checks are run to see the state of payment
									}
								).then(function(result) {
									if (result.error) {
										helper.hideLoader();
										factoryFns.showError(result.error.message, type);
									}
									else {
										//
									}
								});
							})
						})	
					}
				});
			})
		},
		createCustomer: function(data,stripe){ //initial klarna payment intent
			factoryFns.showLoader();
			const customerTokenData = Object.assign({}, data);
			// console.log(customerTokenData)
			//send request to create a customer
			fetch('/checkout/create-customer', { //create new customer key
			  method: 'POST',
			  headers: {
				'Content-Type': 'application/json',
				'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
			  },
			  body: JSON.stringify(customerTokenData)
			}).then(function(result) {
				result.json().then(function(json) {
					if (json.error) {
						// Show error from server on payment form
						helper.hideLoader();
						factoryFns.showError(json.error);
					}else{
						var customer_id = json.customer_id;
						const paymentIntentTokenData = Object.assign({}, data, {data: data, customer_id: customer_id});
						factoryFns.createPaymentIntent(data, stripe, paymentIntentTokenData);
					}
				});
			})
		},
		createPaymentIntent: function(data, stripe, paymentIntentTokenData){
			fetch('/checkout/create-payment-intent', { //create payment intent related the customer id and assign the type to klarna
				method: 'POST',
				headers: {
					'Content-Type': 'application/json',
					'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
				},
				body: JSON.stringify(paymentIntentTokenData)
				}).then(function(result) {
					result.json().then(function(json) {
						// console.log(json);
						const clientSecret = json.payment_intent_client_secret;
						elements = stripe.elements({ clientSecret: clientSecret });

						const paymentElement = elements.create("payment");
						paymentElement.mount("#payment-element");

						factoryFns.hideLoader();
						
						var form = data.type == 'extension' ? document.getElementById('extForm') : document.getElementById('payment-form');
						form.addEventListener('submit', function(e) {
							helper.showLoader();
							e.preventDefault();
							factoryFns.submitPayment(data, stripe);
						});
						

				}).then(function(result) {
						// console.log(result)
				});
			})	
		},
		submitPayment: function(data, stripe){
			stripe.confirmPayment(
				{
				elements: elements,
				confirmParams: {
					  return_url: Config.base_url + 'checkout/payment'
				},
				redirect: "if_required"
			}).then(function(result) {
				// console.log(result)
				if(result.error){
					helper.hideLoader();
					factoryFns.showError(result.error.message);
				}
				else {
					if(data.type != 'extension'){
						factoryFns.finalisePayment(data, stripe, result.paymentIntent.id)
					}
					else {
						factoryFns.finalisePaymentExtension(data, stripe, result.paymentIntent.id)
					}
				}
			})
		},
		finalisePayment: function(data,stripe, payment_id){
			const objectData = Object.assign({}, data, {payment_id: payment_id});
			fetch('/checkout/finalise-payment', { //fully finish the klarna payment
				method: 'POST',
				headers: {
				  'Content-Type': 'application/json',
				  'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
				},
				body: JSON.stringify(objectData)
			  }).then(function(result) {
				//   console.log(result)
				// // Handle server response (see Step 3)
				result.json().then(function(json) {
					$rootScope.$broadcast('saveOrderEvent', { //save the order and complete required requests
						orderID: json.orderID,
						transID: json.transID
					})
					if (json.error) {
					  // Show error from server on payment form
					  helper.hideLoader();
					  factoryFns.showError(json.error);
				  }else{

				  }

				})
			  });
		},
		finalisePaymentExtension: function(data,stripe, payment_id){
			const objectData = Object.assign({}, data, {payment_id: payment_id});
			fetch('/extension/finalise-payment', { //fully finish the klarna payment
				method: 'POST',
				headers: {
				  'Content-Type': 'application/json',
				  'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
				},
				body: JSON.stringify(objectData)
			  }).then(function(result) {
				// // Handle server response (see Step 3)
				result.json().then(function(json) {
					$rootScope.$broadcast('saveExtensionEvent', { //save the order and complete required requests
						status: json.status,
						quoteID: json.ID,
						transID: json.transID
					})
					if (json.error) {
					  // Show error from server on payment form
					  helper.hideLoader();
					  factoryFns.showError(json.error);
				  }else{

				  }

				})
			  });
		},
		showLoader: function(){
			$(".payment-submit").attr('disabled', true);
			document.querySelector("#spinner").classList.remove("hidden");
			// document.querySelector("#button-text").classList.add("hidden");
		},
		hideLoader: function(){
			$(".payment-submit").attr('disabled', false);
			document.querySelector("#spinner").classList.add("hidden");
			// document.querySelector("#button-text").classList.remove("hidden");
		},
	  	showError: function(error){
			var errorElement = document.getElementById('payment-errors');
			errorElement.textContent = error;
	  	},
	  	clearError: function(){
	  		var errorElement = document.getElementById('payment-errors');
			errorElement.textContent = '';
	  	}
	}
	return factoryFns;



}]);